<template>
  <header class="navbar" v-if="!$parent.isAdminPage($route.path, $route.name)">
      <div class="container-fluid">
          <button class="navbar-toggler mobile-toggler hidden-lg-up" type="button">☰</button>
          <router-link to="/dashboard" exact class="navbar-brand" style="padding:0; text-align: center;background-image: none;" >
            <span v-if="!logo">{{ company_name }}</span>
            <img v-else class="logo" v-bind:src="logo">
          </router-link>      
          <ul class="nav navbar-nav hidden-md-down float-xs-left">
              <li class="nav-item">
                  <a class="nav-link navbar-toggler layout-toggler" href="#">☰</a>
              </li>

          </ul>
          <ul class="nav navbar-nav float-xs-right">
              <li class="nav-item dropdown">
                  <a class="nav-link avatar" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                      <!-- <img src="/static/img/avatars/6.jpg" class="img-avatar" alt="admin@bootstrapmaster.com"> -->
                      <i class="icon-user icons font-2xl" style="color: #36a9e1;"></i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                      <router-link :to="{path: '/settings/profile', }" exact class="dropdown-item">
                          <i class="fa fa-user"></i> Profile
                      </router-link>
                      <router-link :to="{path: '/settings', }" exact class="dropdown-item" v-if="permissions.indexOf('reports_read') >= 0">
                          <i class="fa fa-wrench"></i> Settings
                      </router-link>
                      <a class="dropdown-item" href="#" v-on:click.prevent="logout"><i class="fa fa-lock"></i> Logout</a>
                  </div>
              </li>
          </ul>
      </div>
  </header>
</template>

<script>
  export default {
    data () {
      return {
        logo: '',
        company_name: 'The Company Name',
        permissions: (this.$cookies.isKey('op_session_content')) ? JSON.parse(this.$cookies.get('op_session_content')).permissions : []
      }
    },
    created () {
      var company = (this.$cookies.isKey('op_session_content')) ? JSON.parse(this.$cookies.get('op_session_content')) : []
      if (Object.keys(company).length) {
        this.company_name = company.company.name
        this.logo = company.company.logo
      }
    },
    methods: {
      logout: function (event) {
        this.$http.post(process.env.API_ENDPOINT + '/user/logout?token=' + this.$cookies.get('op_session')).then((response) => {
          // response
        }, (response) => {
          // fail
        })

        this.$cookies.remove('op_session')
        this.$cookies.remove('op_session_content')
        this.$cookies.remove('op_session_last')
        this.$router.go('/login')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Header.vue?31b3d493